import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-about",
  "use": "icon-about-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-about\">\n<path d=\"M138.6,30.6c9,7.9,13.5,18.6,13.5,32.2c0,11.3-2.8,20.3-8.5,27.7c-2.3,2.3-8.5,8.5-19.2,17.5c-4,3.4-6.8,7.3-9,11.3\n\tc-2.3,4.5-3.4,9-3.4,14.7v3.4h-26v-3.4c0-8.5,1.1-15.8,4.5-22c2.8-6.2,11.9-15.2,26.5-28.8l2.8-3.4c4-5.1,6.2-10.2,6.2-15.8\n\tc0-7.3-2.3-13-6.2-17.5c-4.5-4.5-10.2-6.2-18.1-6.2c-10.2,0-16.9,2.8-20.9,9c-4,5.1-5.6,12.4-5.6,22H48.8c0-16.4,4.5-29.9,14.7-39\n\tc9.6-9.6,22.6-14.1,39.5-14.1C117.7,18.7,129.6,22.7,138.6,30.6z M111.5,153.1c3.4,3.4,5.1,7.3,5.1,11.9c0,5.1-1.7,9-5.1,12.4\n\tc-3.4,3.4-7.3,4.5-12.4,4.5s-9-1.7-12.4-5.1c-3.4-3.4-5.1-7.3-5.1-11.9c0-5.1,1.7-9,5.1-11.9c3.4-3.4,7.3-4.5,12.4-4.5\n\tC103.6,148.5,108.1,149.7,111.5,153.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/about.svg
// module id = /mzh
// module chunks = 3